var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChassisTrailerWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.7 61.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.5,53.4v-16.8h7.6V.9c1.3,0,2.4-.1,3.5,0,.5,0,.9.8,1.4,1.1s1.2.7,1.7.7h91.7c.8,0,.9,0,1.3-.5.9-1.3,2.2-1.6,3.6-1.4h1.5v35.6h24.1v3.7H6.3v9.4h3.4c.3,0,.6-.7.7-1.1,1.2-3.6,4.5-6.1,8.2-6.4,3.9-.3,7.5,1.8,9.1,5.3,2.3,4.8,0,10.6-4.8,12.7-5,2.1-10.7-.5-12.4-5.6-.3-1-.8-1.2-1.7-1.2H2.5v.2ZM111.2,6.6H14v29.9h96.2c.9,0,1.2-.2,1.2-1.1V6.5h-.2ZM24.9,51.5c0-3.1-2.5-5.7-5.6-5.6-3.1,0-5.6,2.6-5.6,5.7s2.5,5.5,5.6,5.6c3.1,0,5.6-2.5,5.6-5.6h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.8,44h25.7c.8,0,1.4.3,2.1.8,1.7,1.3,2.3,3,2.1,5.1-.2,2.3,0,4.6,0,7.1h-26c-.6,0-1.1-.4-1.6-.7-1.9-1.3-2.5-3-2.3-5.3s0-4.6,0-7.1h0ZM75.5,47.8v3.8c0,1.5.4,1.8,1.9,1.8h20.6v-3.8c0-1.5-.3-1.8-1.9-1.8h-20.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.9,42.2c5.2,0,9.4,4.1,9.4,9.3s-4.2,9.4-9.3,9.4-9.4-4.1-9.4-9.3,4.1-9.4,9.3-9.4ZM40,57.1c3.1,0,5.6-2.5,5.6-5.7s-2.5-5.6-5.6-5.6-5.6,2.5-5.6,5.6,2.5,5.6,5.6,5.6h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.9,51.5c0,5.2-4.2,9.4-9.5,9.3-5.1,0-9.2-4.3-9.2-9.5s4.2-9.2,9.4-9.2,9.3,4.2,9.3,9.4ZM60.5,57.1c3.1,0,5.7-2.5,5.7-5.6s-2.5-5.6-5.5-5.6-5.7,2.5-5.7,5.6,2.4,5.7,5.6,5.7h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChassisTrailerWh);
export default __webpack_public_path__ + "static/media/chassis-trailer-wh.c643a41760edcfa4cf8e275b50eb68ea.svg";
export { ForwardRef as ReactComponent };